import React from "react";
import "../../css/TopBanner.css";
import { strings } from "../../resources/Strings";

const TopBanner = () => {
  return (
    <>
      <div className="topBanner">
        <div className="img">
          <div className="text desktop">
            <p className="text1">{strings.topBanner.text1}</p>
            <p className="text2">{strings.topBanner.text2}</p>
            <p className="text3">{strings.topBanner.text3}</p>
          </div>
        </div>
      </div>
      <div className="topBanner mobile">
        <div className="text">
          <p className="text1">{strings.topBanner.text1}</p>
          <p className="text2">{strings.topBanner.text2}</p>
          <p className="text3">{strings.topBanner.text3}</p>
        </div>
      </div>
    </>
    
  );
};

export default TopBanner;
